import { useBranding } from './portalBrandingState';
import { resolveAuthPresentation } from './brandingPresentation';
import BrandLogoImage from './BrandLogoImage';

// Shared brand header for the secondary auth pages (forgot password, reset
// password, verify email).
//
// The main AlgoSys host shows the bundled AlgoSys platform logo. Any other host
// shows the Operator's safely loaded custom logo, a neutral placeholder while
// branding or the logo is still loading (or after branding failed), and nothing
// when a branded Operator has no usable logo. A branded portal's identity is
// stated as separate text underneath.
export default function AuthBrandLogo({ className = 'h-40 mx-auto object-contain' }) {
  const presentation = resolveAuthPresentation(useBranding());

  return (
    <>
      <BrandLogoImage
        logoSrc={presentation.logoSrc}
        alt={presentation.logoAlt}
        fallback={presentation.logoFallback}
        className={className}
      />
      {presentation.showBusinessNameBadge && (
        <p
          className="mt-2 truncate text-base font-semibold text-brand"
          title={presentation.businessName ?? undefined}
        >
          {presentation.businessName}
        </p>
      )}
    </>
  );
}
